<template>
  <v-tooltip v-if="getStatusInfo(item.status).message" right>
    <template #activator="{ on }">
      <span
        v-if="index === 0"
        class="fill-height pl-5 d-block"
        :class="getStatusInfo(item.status).color"
        style="width: 20px;"
        v-on="on"
      >
      </span>
    </template>
    <span>
      {{ getStatusInfo(item.status).message }}
    </span>
  </v-tooltip>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'StatusTooltip',
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      default: 0
    }
  },
  computed: { ...mapState(['references']) },
  methods: {
    getStatusInfo (status) {
      switch (status) {
        case 'published':
          return { color: 'teal accent-3', message: 'Publié' };
        case 'draft':
          return { color: 'blue-grey lighten-4', message: 'Brouillon' };
        case 'deleted':
          return { color: 'primary', message: 'Offre supprimée' };
        default:
          return { color: 'primary accent-3', message: 'En attente' };
      }
    }
  }
};
</script>
